<template>
  <v-container fluid class="notification-container pa-0">
    <transition-group name="fade" tag="v-row" class="d-flex flex-column" dense>
      <v-col
        v-for="(notification, index) in notificationStore.getReversedActiveNotifications"
        :key="notification.id"
        class="pa-0 mb-2"
        cols="12"
      >
        <AutoDismissAlert :notification="notification" :notification-index="index" />
      </v-col>
    </transition-group>
  </v-container>
</template>

<script lang="ts" setup>
import { useNotificationStore } from '@/store/notificationStore';
import AutoDismissAlert from '@/components/AutoDismissAlert.vue';

const notificationStore = useNotificationStore();

</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 75px; /* Height of the navbar */
  right: 6px;
  z-index: 9999;
  width: 360px;
  max-width: 360px;
  max-height: calc(100vh - 75px - 16px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* Fade transition for items */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
